import { render, staticRenderFns } from "./_PersonalHealthInformation.vue?vue&type=template&id=7cc452ae&scoped=true"
import script from "./_PersonalHealthInformation.vue?vue&type=script&lang=js"
export * from "./_PersonalHealthInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc452ae",
  null
  
)

export default component.exports